import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'formatTime',
    standalone: false
})
export class FormatTimePipe implements PipeTransform {

    constructor(private translate: TranslateService) {
    }


    static format(date: Date, translate: TranslateService): string {
        let m = translate.instant('date.am');
        let hours: any = date.getHours();
        if (hours > 12) {
            hours -= 12;
            m = translate.instant('date.pm');
        }
        if (hours < 10) {
            hours = '0' + hours;
        }
        let mins: any = date.getMinutes();
        if (mins < 10) {
            mins = '0' + mins;
        }
        return `${hours}:${mins} ${m}`;
    }

    transform(value: string): any {
        const date = new Date(value);
        return FormatTimePipe.format(date, this.translate);
    }
}
